import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=5f144682&scoped=true&lang=pug"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f144682",
  null
  
)

export default component.exports